import React from "react";
import "./Support.scss";

// icons
import icon1 from "../../Assets/spn1.png";
import icon2 from "../../Assets/spn2.png";
import icon3 from "../../Assets/spn3.png";
import icon4 from "../../Assets/spn4.png";
import icon5 from "../../Assets/spn5.png";
import icon6 from "../../Assets/spn6.png";
import icon7 from "../../Assets/spn7.png";
import icon8 from "../../Assets/spn8.png";

// data array
const supportData = [
  { icon: icon1, title: "Set your budget", desc: "Say how much you can spend and how far you'll travel—compare prices without many consultation fees." },
  { icon: icon2, title: "Clear written quotes", desc: "See what is included in each bill before you agree." },
  { icon: icon3, title: "Verified doctors & hospitals", desc: "Care partners are checked before they can send you a price." },
  { icon: icon4, title: "Updates in the app", desc: "See when a doctor or hospital replies with a new price." },
  { icon: icon5, title: "Compare in one place", desc: "Read several surgery prices side by side." },
  { icon: icon6, title: "Human support", desc: "Call or message us if a quote or term is unclear." },
  { icon: icon7, title: "Help with booking", desc: "We help with appointment timing, admission, and follow-ups." },
  { icon: icon8, title: "Less price confusion", desc: "Know what you're paying for before you commit." },
];

export default function Support() {
  return (
    <div className="support_section">
      <div className="container ">

        <div className="suport">
          <h2>
            Support <span className='wgreen'>You Can</span> Trust
          </h2>
        </div>

        <div className="support_grid">
          {supportData.map((item, index) => (
            <div className="support_card" key={index}>

              {/* UNIQUE IMAGE */}
              <div className="icon_box">
                <span>
                  <img src={item.icon} alt="" />
                </span>
              </div>

              {/* TEXT */}
              <div className="card_text">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
